<app-dialog-header 
  [title]="VerificaVendaTipo(venda.vendaTipo) + ' - ' + venda.vendaId"
  [buttons]="dialogButtons"
  [maximizado]="maximizado"
  [element]="venda"
  [templateAcoes]="valoresTemplate"
  [showTabs]="true"
  [tabs]="[{id: 0, label: 'Geral'}, {id: 1, label: 'Entrega e Transporte'}, {id: 2, label: 'Observações'}]"
  [selectedTab]="selectedTab"
  (tabChange)="selectedTab = $event"
  [showErrorBanner]="mostrarErrosValidacao"
  [errorTitle]="'ATENÇÃO:'"
  [errorMessages]="getErrorMessages()"
  (closeErrorBanner)="fecharAvisoErros()"
  (maximize)="maximizarDialog()"
  (restore)="restaurarDialog()"
  (close)="fecharDialog()">
</app-dialog-header>

<mat-dialog-content>
  <form [formGroup]="vendaCadastroForm">
    <ng-template #valoresTemplate>
  <app-valores-totais 
    [totalBruto]="vendaCadastroForm.get('valorBruto')?.value || 0"
    [totalLiquido]="calcularTotalLiquido()"
    [descontosItens]="vendaCadastroForm.get('descontosItensEmReais')?.value || 0"
    [desconto]="vendaCadastroForm.get('descontoEmPorcentagem')?.value || 0"
    [descontoAdicional]="vendaCadastroForm.get('descontosAdicionaisEmReais')?.value || 0">
  </app-valores-totais>
</ng-template>

      <!-- 0: Geral -->
      <div class="tab-content" *ngIf="selectedTab === 0">
      <div class="section-container">
      <h3>Geral</h3>
        <br />
        <div class="row">
          <mat-form-field class="col-md-6 col-xs-12 form-group">
            <mat-label>Emitente</mat-label>
            <mat-select formControlName="empresaId" (selectionChange)="buscaListaServico($event.value)">
              <mat-option *ngFor="let empresa of empresas" [value]="empresa.empresaId">
                {{ empresa.nomeFantasia }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="col-md-6 col-xs-12 form-group">
            <mat-label>Vendedor</mat-label>
            <mat-select formControlName="vendedorId">
              <mat-option *ngFor="let vendedor of vendedores" [value]="vendedor.funcionarioId">
                {{vendedor.nomeFantasia}}
              </mat-option>
            </mat-select>
            <mat-hint>Para cadastrar vendedores acesse RH > Funcionários > E
              selecione o Tipo de Função 'Vendedor'</mat-hint>
          </mat-form-field>

        </div>
        <div class="row">
          <mat-form-field class="col-md-6 col-xs-12 form-group">
            <mat-label>Cliente</mat-label>
            <input type="text" matInput [matAutocomplete]="auto" formControlName="clienteAutoComplete">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let parceiro of clientes" [value]="parceiro.nomeFantasia"
                (click)="determinaCliente(parceiro)">
                CNPJ: {{parceiro.cnpj}} - {{parceiro.nomeFantasia}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div class="col-md-3">
            <mat-form-field>
              <mat-label>Data da Venda</mat-label>
              <input matInput [matDatepicker]="picker1" formControlName="dataVenda">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field>
              <mat-label>Data Entrega</mat-label>
              <input matInput [matDatepicker]="picker2" formControlName="dataPrevista">
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
              <mat-hint>Data prevista para entrega</mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="row" *ngIf="parceirosEncontrados == false">
          <div class="col-md-6 col-xs-12 form-group">
            <p>Nenhum cliente com o nome "{{vendaCadastroForm.value.clienteAutoComplete}}" foi encontrado.</p>
            <a (click)="clienteModal(0, vendaCadastroForm.value.clienteAutoComplete)" style="color: #F37431; text-decoration: underline; cursor: pointer;">
              Criar um novo cliente com esse nome
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-xs-12 form-group">
            <label id="example-radio-group-label">Selecione o tipo de Venda:</label>
            <mat-radio-group aria-label="Selecione uma opção" class="col-md-12 col-xs-12 form-group"
              formControlName="naturezaVenda">
              <mat-radio-button [value]="0">Nova Venda</mat-radio-button>
              <mat-radio-button [value]="1">Renovação</mat-radio-button>
            </mat-radio-group>
        </div>
        </div>
      </div>
      <hr>
      <div *ngIf="vendaCadastroForm.get('vendaStatus').value < 4">
        <h3>Itens</h3>
        <app-itens [getProdutoPorNomeEEmpresasService]="getProdutoPorNomeEEmpresasService.bind(this)"
          [empresas]="empresas" [itens]="venda.vendaItens ? venda.vendaItens : []"
          (novosItens)="onItensChange($event)" [panelOpenState]="true"
          (valorTotalBruto)="onValorTotalBrutoChange($event)"
          (descontosAplicadosAosItens)="onDescontosAplicadosAosItensChange($event)"
          (valorTotalLiquido)="onValorTotalLiquidoChange($event)"></app-itens>
      </div>
        <div class="section-container">
          <h3>Desconto Adicional</h3>
          <div class="row">
            <mat-form-field class="col-md-3 col-xs-6 form-group" (input)="limitarValor()">
              <mat-label>Desconto em %</mat-label>
              <input (input)="changePorcentagem()" type="number" step="0.001" min="0" max="100" matInput
                formControlName="descontoEmPorcentagem">
            </mat-form-field>
            <mat-form-field class="col-md-3 col-xs-6 form-group" (input)="limitarValor()">
              <mat-label>Desconto em R$</mat-label>
              <input type="number" (input)="changeEmReal()" matInput formControlName="descontoValorEmReal">
            </mat-form-field>
            <div class="col-md-5 col-xs-12" style="margin-top: 10px;">
              <app-status-card
                texto="Descontos Totais: {{(vendaCadastroForm.value.descontosItensEmReais + vendaCadastroForm.value.descontosAdicionaisEmReais) | currency}}"
                cor="azul"
                icone="request_quote"
                backgroundColor="#f5f9ff"
                [descricao]="'Descontos dos Itens: ' + (vendaCadastroForm.value.descontosItensEmReais | currency) + '<br>Desconto Adicional: ' + (vendaCadastroForm.value.descontosAdicionaisEmReais | currency) + ' (' + ((vendaCadastroForm.value.descontoEmPorcentagem || 0) | number:'1.3-3':'pt-BR') + '%)'">
              </app-status-card>
            </div>
          </div>
        </div>
  <hr>
      <div class="section-container">
        <h3>Informações de pagamento</h3>
        <br />
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="row">
              <mat-form-field class="col-md-6 col-xs-12 form-group">
                <mat-label>Indicador de Pagamento</mat-label>
                <mat-select formControlName="indPag" name="indPag">
                  <mat-option [value]="0">Pagamento a vista</mat-option>
                  <mat-option [value]="1">Pagamento a prazo</mat-option>
                  <mat-option [value]="2">Outros</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-6 col-xs-12 form-group">
                <mat-label>Tipo de Pagamento</mat-label>
                <mat-select formControlName="tipoPagamento" name="tipoPagamento">
                  <mat-option [value]="0">Dinheiro</mat-option>
                  <mat-option [value]="1">Débito</mat-option>
                  <mat-option [value]="2">Crédito</mat-option>
                  <mat-option [value]="3">Boleto</mat-option>
                  <mat-option [value]="11">PIX</mat-option>
                  <mat-option [value]="4">Transferência</mat-option>
                  <mat-option [value]="5">Cheque</mat-option>
                  <mat-option [value]="6">Vale Refeição</mat-option>
                  <mat-option [value]="7">Banco</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-3 col-xs-12 form-group" *ngIf="venda.vendaTipo != 1">
                <mat-label>Consumidor Final</mat-label>
                <mat-select formControlName="indFinal" name="indFinal">
                  <mat-option [value]="0">Normal</mat-option>
                  <mat-option [value]="1">Consumidor final</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-3 col-xs-12 form-group" *ngIf="venda.vendaTipo != 1">
                <mat-label>Forma de Emissão</mat-label>
                <mat-select formControlName="indPres" name="indPres">
                  <mat-option [value]="0">Não se aplica</mat-option>
                  <mat-option [value]="1">Operação presencial</mat-option>
                  <mat-option [value]="2">Operação não presencial, pela Internet
                  </mat-option>
                  <mat-option [value]="3">Operação não presencial, Teleatendimento
                  </mat-option>
                  <mat-option [value]="4">NFC-e em operação com entrega a domicílio
                  </mat-option>
                  <mat-option [value]="9">Operação não presencial, outros</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12">
            <h3>Parcelas</h3>
            <br />
            <app-calcula-parcelas
              [valorTotal]="(vendaCadastroForm.value.valorBruto - vendaCadastroForm.value.descontosItensEmReais - vendaCadastroForm.value.descontosAdicionaisEmReais)"
              [valorLiquido]="(vendaCadastroForm.value.valorBruto - vendaCadastroForm.value.descontosItensEmReais - vendaCadastroForm.value.descontosAdicionaisEmReais)"
              [tipoPagamento]="vendaCadastroForm.get('indPag').value"
              [numeroParcelas]="vendaCadastroForm.get('numeroParcelas').value"
              [vencimento]="currentDate"
              [parcelasIniciais]="parcelasIniciais"
              [parcelaIdNome]="'vendaParcelaId'"
              [intervaloParcelas]="30"
              (parcelasFinaisChange)="onParcelasFinaisChange($event)">
            </app-calcula-parcelas>
          </div>
        </div>
      </div>
      </div>
      
      <!-- 1: Entrega e Transporte -->
      <div class="tab-content" *ngIf="selectedTab === 1">
      <div class="section-container">
        <h3>Transporte e Entrega</h3>
        <br />
        <div class="row">
          <mat-form-field class="col-md-6 col-xs-12 form-group">
            <mat-label>Transportadora</mat-label>
            <mat-select formControlName="transportadoraId">
              <mat-option *ngFor="let transportadora of transportadoras" [value]="transportadora.transportadoraId">
                {{transportadora.nomeFantasia}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="col-md-6 col-xs-12 form-group">
            <mat-label>Local de Entrega</mat-label>
            <input type="text" matInput [matAutocomplete]="localEntregaMatAutocomplete"
              formControlName="localEntregaAutoComplete">
            <mat-autocomplete #localEntregaMatAutocomplete="matAutocomplete">
              <mat-option *ngFor="let localEntrega of locaisEntrega" [value]="localEntrega.nomeFantasia"
                (click)="DeterminalocalEntregaId(localEntrega.clienteId)">
                CNPJ: {{localEntrega.cnpj}} - {{localEntrega.nomeFantasia}}
              </mat-option>
            </mat-autocomplete>
            <mat-hint>Local de Entrega (se diferente do destinatário)</mat-hint>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="col-md-6 col-xs-12 form-group">
            <mat-label>Tipo de Entrega</mat-label>
            <mat-select formControlName="tipoEntrega" name="tipoEntrega">
              <mat-option [value]="1">Transportadora</mat-option>
              <mat-option [value]="2">Veículo Próprio</mat-option>
              <mat-option [value]="3">Cliente Retira</mat-option>
              <mat-option [value]="4">Correios</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="col-md-6 col-xs-12 form-group">
            <mat-label>Tipo de Frete</mat-label>
            <mat-select formControlName="modFrete" name="modFrete">
              <mat-option [value]="0">Contratação do frete por conta do remetente (CIF)
              </mat-option>
              <mat-option [value]="1">Contratação do frete por conta do destinatário (FOB)
              </mat-option>
              <mat-option [value]="2">Transporte próprio por conta do remetente</mat-option>
              <mat-option [value]="3">Transporte próprio por conta do destinatário
              </mat-option>
              <mat-option [value]="9">Sem ocorrência de transporte</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="col-md-6 col-xs-12 form-group">
            <mat-label>Quantidade de Volumes Transportados</mat-label>
            <input type="number" matInput formControlName="qVol">
          </mat-form-field>
          <mat-form-field class="col-md-6 col-xs-12 form-group">
            <mat-label>Espécie dos Volumes Transportados</mat-label>
            <input type="text" matInput formControlName="especie">
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field class="form-group col-md-6 col-xs-12">
            <mat-label>Peso Líquido (KG)</mat-label>
            <input type="number" matInput formControlName="pesoBruto">
          </mat-form-field>
          <mat-form-field class="form-group col-md-6 col-xs-12">
            <mat-label>Peso Bruto (KG)</mat-label>
            <input type="number" matInput formControlName="pesoLiquido">
          </mat-form-field>
        </div>
      </div>
  <hr>
  <div style="display:flex; justify-content: center; background-color: #c3c3c3; display: none">
    <div class="danfe" id="printVenda">
      <div class="page" *ngFor="let vendatemp of vendas">
        <div class="bloco">
          <table id="dados-nfe" class="tabelaDanfe">
            <thead>
              <tr>
                <td class="campo">
                  <img [src]="'data:image/JPEG;base64,'+ empresa.logoByte" id="logoCliente">
                </td>
                <td rowspan="4" class="campo quadro-identificacao-emitente">
                  <div class="conteudoPedido negrito">
                    <h3>{{'Pedido de Venda'}}
                    </h3>
                    <h5>{{empresa.nomeFantasia}}</h5>
                  </div>
                  <div class="conteudoPedido">
                    {{empresa.logradouro}}, {{empresa.numero}} , {{empresa.bairro}} <br />
                    {{empresa.municipio?.descricao}} - {{empresa.municipio?.uf.siglaUF}}, CEP:
                    {{empresa.cep}}
                    <br />
                    Tel: {{empresa.telefone}} <br />
                    e-mail: {{empresa.emailVenda}} <br />
                    IE: {{empresa.inscEstadual}} - CNPJ: {{empresa.cnpj}}
                  </div>
                </td>
                <td class="campo data-emissao">
                  <br>
                  <div class="conteudoPedido negrito">EMISSÃO</div>
                  <div class="conteudoPedido">
                    <h5>{{vendatemp.dataVenda | date:'dd/MM/yyyy'}}</h5>
                  </div>
                  <div class="conteudoPedido negrito">PEDIDO</div>
                  <div class="conteudoPedido negrito">
                    <h5>{{vendatemp.vendaId}}</h5>
                  </div>
                  <div class="conteudoPedido negrito">FATURA</div>
                  <div class="conteudoPedido negrito">
                    <h5>{{vendatemp.faturaId}}</h5>
                  </div>
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <div class="bloco">
          <div class="conteudoPedido negrito fonte-7-pontos">DESTINATÁRIO/REMETENTE</div>
          <table>
            <tr>
              <td colspan="3" class="campo razao-social">
                <div class="conteudoPedido fonte-5-pontos">NOME / RAZÃO SOCIAL</div>
                <div class="conteudoPedido">
                  {{cliente.razaoSocial}}
                </div>
              </td>
              <td class="campo cnpj-destinatario">
                <div class="conteudoPedido fonte-5-pontos">CNPJ / CPF</div>
                <div class="conteudoPedido">
                  {{cliente.cnpj != undefined ? cliente.cnpj : cliente.cpf}}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="campo endereco-destinatario">
                <div class="conteudoPedido fonte-5-pontos">ENDEREÇO</div>
                <div class="conteudoPedido">
                  {{cliente.logradouro}} &nbsp;
                  {{cliente.numero}}
                </div>
              </td>
              <td class="campo bairro-destinatario">
                <div class="conteudoPedido fonte-5-pontos">BAIRRO / DISTRITO</div>
                <div class="conteudoPedido">
                  {{cliente.bairro}}
                </div>
              </td>
              <td class="campo cep-destinatario">
                <div class="conteudoPedido fonte-5-pontos">CEP</div>
                <div class="conteudoPedido">
                  {{cliente.cep}}
                </div>
              </td>
            </tr>
            <tr>
              <td class="campo municipio-destinatario">
                <div class="conteudoPedido fonte-5-pontos">MUNICÍPIO</div>
                <div class="conteudoPedido">
                  {{cliente.municipio?.descricao}}
                </div>
              </td>
              <td class="campo fone-fax-destinatario">
                <div class="conteudoPedido fonte-5-pontos">TELEFONE</div>
                <div class="conteudoPedido">
                  {{cliente.telefone}}
                </div>
              </td>
              <td class="campo uf-destinatario">
                <div class="conteudoPedido fonte-5-pontos">UF</div>
                <div class="conteudoPedido">
                  {{cliente.municipio?.uf.siglaUF}}
                </div>
              </td>
              <td class="campo inscricao-destinatario">
                <div class="conteudoPedido fonte-5-pontos">INSCRIÇÃO ESTADUAL</div>
                <div class="conteudoPedido">
                  {{cliente.inscEstadual}}
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="bloco">
          <div class="conteudoPedido negrito fonte-7-pontos">TRANSPORTE</div>
          <table>
            <tr>
              <td colspan="3" class="campo razao-social">
                <div class="conteudoPedido fonte-5-pontos">NOME / RAZÃO SOCIAL</div>
                <div class="conteudoPedido" *ngIf="transportadora != undefined">
                  {{transportadora.razaoSocial}}
                </div>
              </td>
              <td class="campo endereco-destinatario">
                <div class="conteudoPedido fonte-5-pontos">CNPJ / CPF</div>
                <div class="conteudoPedido" *ngIf="transportadora != undefined">
                  {{transportadora.cnpj}}
                </div>
              </td>
            </tr>
          </table>
          <table class="sem-borda-superior">
            <tr>
              <td class="campo municipio-destinatario">
                <div class="conteudo fonte-5-pontos">MODALIDADE DO FRETE</div>
                <div class="conteudo">
                  {{vendatemp.modalidadeFrete}}
                </div>
              </td>
              <td class="campo quantidade-transportador">
                <div class="conteudo fonte-5-pontos">QUANTIDADE</div>
                <div class="conteudo">
                  {{vendatemp.volumesTransportados}}
                </div>
              </td>
              <td colspan="2" class="campo especie-transportador">
                <div class="conteudo fonte-5-pontos">ESPÉCIE</div>
                <div class="conteudo">
                  {{vendatemp.especieVolumesTransportados}}
                </div>
              </td>
              <td class="campo peso-bruto-transportador">
                <div class="conteudo fonte-5-pontos">PESO BRUTO</div>
                <div class="conteudo">
                  {{vendatemp.pesoBrutoTransportado}}
                </div>
              </td>
              <td class="campo peso-liquido-transportador">
                <div class="conteudo fonte-5-pontos">PESO LÍQUIDO</div>
                <div class="conteudo">
                  {{vendatemp.pesoLiquidoTransportado}}
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="bloco">
          <div class="conteudoPedido negrito fonte-7-pontos">VALORES TOTAIS</div>
          <table>
            <tr>
              <td class="campo base-calculo-icms">
                <div class="conteudoPedido fonte-5-pontos">TOTAL DA VENDA</div>
                <div class="conteudoPedido">
                  R$ {{vendatemp.totalVenda | number:'1.2-2'}}
                </div>
              </td>
              <td class="campo valor-do-icms">
                <div class="conteudoPedido fonte-5-pontos">DESCONTOS</div>
                <div class="conteudoPedido">
                  R$ {{vendatemp.totalDescontos | number:'1.2-2'}}
                </div>
              </td>
              <td class="campo base-de-cálculo-do-icms-st">
                <div class="conteudoPedido fonte-5-pontos">TOTAL GERAL</div>
                <div class="conteudoPedido">
                  R$ {{vendatemp.totalGeral| number:'1.2-2'}}
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="bloco">
          <div class="conteudoPedido negrito fonte-7-pontos">DADOS DOS PRODUTOS / SERVIÇOS</div>
          <table id="dados-produtos">
            <thead>
              <tr>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">CÓDIGO</div>
                </th>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">DESCRIÇÃO DOS PRODUTOS / SERVIÇOS
                  </div>
                </th>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">NCM</div>
                </th>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">LOTE</div>
                </th>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">UNID</div>
                </th>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">QUANT</div>
                </th>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">VLR.UNIT.</div>
                </th>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">VLR.TOTAL</div>
                </th>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">DESC.</div>
                </th>
                <th class="campo">
                  <div class="conteudoPedido fonte-5-pontos">COM DESC.</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of vendatemp.vendaItens">
                <!--<td class="campo sem-borda-superior-inferior">-->
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    {{item.codProd}}
                  </div>
                </td>
                <!--<td class="campo sem-borda-superior-inferior">-->
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    {{item.descricao}}
                  </div>
                </td>
                <!--<td class="campo sem-borda-superior-inferior">-->
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    {{item.ncm}}
                  </div>
                </td>
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    {{item.numLote}}
                  </div>
                </td>
                <!--<td class="campo sem-borda-superior-inferior">-->
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    {{item.unComercial}}
                  </div>
                </td>
                <!--<td class="campo sem-borda-superior-inferior">-->
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    {{item.qtdComercial}}
                  </div>
                </td>
                <!--<td class="campo sem-borda-superior-inferior">-->
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    R$ {{item.vlrComercial | number:'1.2-2'}}
                  </div>
                </td>
                <!--<td class="campo sem-borda-superior-inferior">-->
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    R$ {{item.valorTotal | number:'1.2-2'}}
                  </div>
                </td>
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    R$ {{item.valorDesconto | number:'1.2-2'}}
                  </div>
                </td>
                <td class="campo ">
                  <div class="conteudoPedido fonte-5-pontos">
                    R$ {{item.valorBruto | number:'1.2-2'}}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="bloco rodape">
          <!--ng-if="page.isLastPage"-->
          <table id="dados_adicionais">
            <tr>
              <td class="campo">
                <div class="conteudoPedido negrito">DADOS ADICIONAIS</div>
              </td>
              <td class="campo">
                <div class="conteudoPedido negrito">END. ENTREGA</div>
              </td>
            </tr>
            <tr>
              <td class="campo dados-adicionais">
                <div class="conteudoPedido">
                  {{vendatemp.dadosAdicionais}}
                </div>
              </td>
              <td class="campo reservado-fisco">
                <div class="conteudoPedido" *ngIf="localEntrega != null">
                  {{localEntrega.logradouro}} {{localEntrega.numero}} <br />
                  {{localEntrega.bairro}}<br />
                  {{localEntrega?.municipio?.descricao}},
                  {{localEntrega?.municipio?.uf.siglaUF}}<br />
                  {{localEntrega.cep}} <br />
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
      </div>
      
      <!-- 2: Observações -->
      <div class="tab-content" *ngIf="selectedTab === 2">
        <div class="section-container">
          <h3>Observações</h3>
          <br />
          <div class="row">
            <mat-form-field class="form-group col-md-12">
              <mat-label>Comunicação Interna</mat-label>
              <textarea matInput rows="5" formControlName="comunicacaoInterna"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
  </form>
</mat-dialog-content>
